/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
import { Fragment, useEffect } from "react";
import { BreadCrumb } from "ui/bread-crumbs";
import { PATHS } from "routes/paths";
import Loader from "ui/page-loader";
import { useLookupCashCenters, useLookupCustomers } from "services/lookups";
import ServiceCallsReports from "./service-calls";
import AllCallsReports from "./all-calls";
import EmailReports from "./email-reports";
import { useUser } from "hooks/use-user";
import EmailMaintenanceReports from "./email-maintenance-reports";

export default function Reports() {
  // const user = useUser();
  // const largeDataUser = user.Roles.includes("Large Data Set User");
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();
  const {
    mutate: getCashCenter,
    data: cashCenterListRes,
    isPending: gettingCashCenterList,
  } = useLookupCashCenters();

  useEffect(() => {
    getCustomersList();
    getCashCenter();
  }, []);

  return (
    <>
      {gettingCashCenterList || gettingCustomersList ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          items={[
            { to: PATHS.dashboard, text: `Dashboard` },
            {
              text: `Reports`,
            },
          ]}
        />

        <AllCallsReports
          customersList={customersListRes?.data || []}
          cashCentersList={cashCenterListRes?.data || []}
        />

        <ServiceCallsReports
          customersList={customersListRes?.data || []}
          cashCentersList={cashCenterListRes?.data || []}
        />
        {/* {largeDataUser ? (
          <>
            <EmailReports
              customersList={customersListRes?.data || []}
              cashCentersList={cashCenterListRes?.data || []}
            />
            <EmailMaintenanceReports
              customersList={customersListRes?.data || []}
              cashCentersList={cashCenterListRes?.data || []}
            />
          </>
        ) : (
          <></>
        )} */}
      </div>
    </>
  );
}
